import React from 'react';
import { Section } from '../layout/Section';
import { MenuCard } from '../features/MenuCard';
import menuHighlights from '../../data/menu-highlights.json';
import type { MenuData } from '../../types/menu';

export const MenuSection: React.FC = () => {
  const { categories } = menuHighlights as MenuData;
  const sortedCategories = [...categories].sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <Section
      id="speisekarte"
      variant="darker"
      aria-labelledby="menu-heading"
    >
      {/* Section Header */}
      <div className="text-center mb-16">
        <h2
          id="menu-heading"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
        >
          Unsere Speisekarte
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto rounded-full" aria-hidden="true" />
        <p className="mt-4 text-gray-400 text-base max-w-xl mx-auto">
          Eine Auswahl unserer Gerichte – mediterran inspiriert, mit Liebe zubereitet
        </p>
      </div>

      {/* Highlights — two-column layout on desktop */}
      <div className="space-y-16 max-w-5xl mx-auto">
        {sortedCategories.map((category) => (
          <div key={category.id}>
            {/* Category Header */}
            <div className="flex items-center gap-4 mb-8">
              <h3 className="text-xl sm:text-2xl font-light tracking-[0.2em] text-[#c9a84c] uppercase whitespace-nowrap">
                {category.name}
              </h3>
              <div className="flex-1 h-px bg-[#c9a84c]/20" aria-hidden="true" />
            </div>

            {/* Menu Items — 1 col mobile, 2 col desktop */}
            <div
              className="grid grid-cols-1 md:grid-cols-2 gap-x-12"
              role="list"
              aria-label={`${category.name}`}
            >
              {category.items.map((item) => (
                <div key={item.id} role="listitem">
                  <MenuCard item={item} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Full menu hint */}
      <div className="text-center mt-16">
        <div className="inline-flex items-center gap-3 px-8 py-4 border border-[#c9a84c]/30 rounded-lg text-gray-400 text-sm">
          <svg className="w-4 h-4 text-[#c9a84c]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Die vollständige Speisekarte liegt bei uns im Restaurant für Sie bereit
        </div>
      </div>
    </Section>
  );
};
